import { ArrowLeft, ArrowRight, ChevronLeft, ChevronRight, ChevronsLeft, ChevronsRight } from 'lucide-react';
import React from 'react';

interface PaginationProps {
    pagination: {
        totalRecords: number
        totalPages: number
        pageIndex: number
        pageSize: number
    }
    isLoading: boolean
    onPageChange: (page: number) => void
    label?: string
}

export default function Pagination({
                                       pagination,
                                       isLoading,
                                       onPageChange,
                                       label = "bản ghi",
                                   }: PaginationProps) {
    if (pagination.totalRecords === 0) return null

    return (
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3 mt-4">
            {/* Thông tin hiển thị */}
            <div className="text-sm text-gray-700">
                Hiển thị{" "}
                <span className="font-medium">
          {(pagination.pageIndex - 1) * pagination.pageSize + 1}
        </span>{" "}
                đến{" "}
                <span className="font-medium">
          {Math.min(
              pagination.pageIndex * pagination.pageSize,
              pagination.totalRecords
          )}
        </span>{" "}
                trong tổng số{" "}
                <span className="font-medium">{pagination.totalRecords}</span>{" "}
                {label}
            </div>

            {/* Nút phân trang */}
            <div className="flex flex-wrap space-x-2">
                <button
                    onClick={() => onPageChange(1)}
                    disabled={pagination.pageIndex === 1 || isLoading}
                    className={`px-3 py-1 rounded-md ${
                        pagination.pageIndex === 1 || isLoading
                            ? "bg-gray-200 cursor-not-allowed"
                            : "bg-gray-200 hover:bg-gray-300"
                    }`}
                >
                    <ChevronsLeft />
                </button>
                <button
                    onClick={() => onPageChange(pagination.pageIndex - 1)}
                    disabled={pagination.pageIndex === 1 || isLoading}
                    className={`px-3 py-1 rounded-md ${
                        pagination.pageIndex === 1 || isLoading
                            ? "bg-gray-200 cursor-not-allowed"
                            : "bg-gray-200 hover:bg-gray-300"
                    }`}
                >
                    <ChevronLeft />
                </button>

                {Array.from(
                    { length: Math.min(5, pagination.totalPages) },
                    (_, i) => {
                        let pageNum: number
                        if (pagination.totalPages <= 5) {
                            pageNum = i + 1
                        } else if (pagination.pageIndex <= 3) {
                            pageNum = i + 1
                        } else if (pagination.pageIndex >= pagination.totalPages - 2) {
                            pageNum = pagination.totalPages - 4 + i
                        } else {
                            pageNum = pagination.pageIndex - 2 + i
                        }

                        return (
                            <button
                                key={pageNum}
                                onClick={() => onPageChange(pageNum)}
                                disabled={isLoading}
                                className={`px-3 py-1 rounded-md ${
                                    pagination.pageIndex === pageNum
                                        ? "bg-blue-600 text-white"
                                        : "bg-gray-200 hover:bg-gray-300"
                                }`}
                            >
                                {pageNum}
                            </button>
                        )
                    }
                )}

                <button
                    onClick={() => onPageChange(pagination.pageIndex + 1)}
                    disabled={
                        pagination.pageIndex === pagination.totalPages || isLoading
                    }
                    className={`px-3 py-1 rounded-md ${
                        pagination.pageIndex === pagination.totalPages || isLoading
                            ? "bg-gray-200 cursor-not-allowed"
                            : "bg-gray-200 hover:bg-gray-300"
                    }`}
                >
                    <ChevronRight />
                </button>
                <button
                    onClick={() => onPageChange(pagination.totalPages)}
                    disabled={
                        pagination.pageIndex === pagination.totalPages || isLoading
                    }
                    className={`px-3 py-1 rounded-md ${
                        pagination.pageIndex === pagination.totalPages || isLoading
                            ? "bg-gray-200 cursor-not-allowed"
                            : "bg-gray-200 hover:bg-gray-300"
                    }`}
                >
                    <ChevronsRight />
                </button>
            </div>
        </div>
    )
}
